import { useEffect, useState } from "react";
import axios from 'axios';
import Main from '../../../component/Main';
import FidelityCommon from "./FidelityCommon";
import ExcelDownload from "../../../component/common/button/ExcelDownload";
import MergedTableHeader from "../../../component/common/dataGrid/MergedTableHeader";
import Loading from "../../../component/common/loading/Loading";

import '../../../css/data-grid.css';
import * as Icons from '../../../images/icons/icons_component';
import { useDynamicStyle } from "../../../hooks/useDynamicStyle";
import { useSubIcon } from "../../../hooks/useSubIcon";

const FidelityInputStatic = () => {

    const today = new Date();
    const currentYear = today.getFullYear();
    let currentMonth = today.getMonth() + 1;
    if (currentMonth < 10) {
        currentMonth = "0" + currentMonth;
    }

    const [searchParams, setSearchParams] = useState({
        searchFromdate: '',
        searchTodate: '',
        searchDateCls: '',
        searchGrdc: '',
        searchType: 'M',
        searchCheck1: currentYear,
        searchCheck2: '',
    });
    const dataHead = [['영역명', '항목명', '정보관리', '정보관리', '정보관리', '정보관리', '정보관리', '정보관리'],
    ['영역명', '항목명', '정상 건수', '정상률(%)', '재검토 건수', '재검토율(%)', '오류 건수', '오류율(%)']];
    const dataColumn = ['RELM_NAME', 'IEM_NAME', 'NRMLT_CO', 'NRMLT_STRE_RT', 'RECHECK_CO', 'RE_EXMNT_RT', 'ERROR_CO', 'ERRORRT'];
    const excelFileName = `충실도_전송내역_관리`;
    const apiCall = '/ptmiapi/fidelitySendStaticList.do';
    const apiCntCall = '';
    const mergeConfig = [{ key: 'RELM_NAME', row: null }];
    const [total, setTotal] = useState([]);

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });
    const popupPropsInfo = {
        checked: ['RECHECK_CO', 'ERROR_CO', 'RE_EXMNT_RT', 'ERRORRT'],
        localStorageName: 'fidelityInput',
        popupAddress: "/nedis/trmsInfo/trms_fidelityCommon_popup.do",
    };

    const fetchData = async () => {
        try {
            const response = await axios.get(apiCall,
                { params: searchParams }
            );
            const response2 = await axios.get('/ptmiapi/fidelitySendStaticListCnt.do',
                { params: searchParams }
            );
            setTotal(response2.data);
            setState(prev => ({
                ...prev,
                dataList: response.data,
                isSearched: true
            }));

            if (apiCntCall === '') {
                setPageInfo(prev => ({
                    ...prev,
                    totalItems: response.data.length
                }));
            } else {
                fetchDataCnt();
            }
            setState(prev => ({
                ...prev,
                isLoading: false
            }));
        } catch (error) {
            console.error('데이터 로딩 중 오류 발생:', error);
        }
    };

    const fetchDataCnt = async () => {
        try {
            const response = await axios.get(apiCntCall,
                { params: searchParams }
            );
            setPageInfo(prev => ({
                ...prev,
                totalItems: response.data
            }));
        } catch (error) {
            console.error('데이터 카운터 중 오류 발생:', error);
        }
    };

    const search = () => {
        setState(prev => ({
            ...prev,
            isSearched: false,
            isLoading: true
        }));
        setPageInfo(prev => ({
            ...prev,
            currentPage: 1,
        }));
        fetchData();
    };

    const computeRowSpans = (dataList, mergeConfig = [], allColumns = []) => {
        const rowSpans = dataList.map(() => ({}));
        // 병합 기준이 되는 마스터 컬럼
        const masterMerge = mergeConfig.find(m => m.row === null);
        const masterKey = masterMerge?.key;
        // 1. 기준 컬럼 기준으로 병합 구간 나누기
        const mergeBlocks = [];
        let blockStart = 0;
        for (let i = 1; i <= dataList.length; i++) {
            const curr = dataList[i];
            const prev = dataList[i - 1];
            const isSameGroup =
                i < dataList.length &&
                dataList[i][masterKey] === dataList[i - 1][masterKey] &&
                dataList[i][masterKey] !== null &&
                dataList[i][masterKey] !== '';
            if (!isSameGroup) {
                mergeBlocks.push({ start: blockStart, end: i });
                blockStart = i;
            }
        }
        // 2. 기준 컬럼 병합 수행
        mergeBlocks.forEach(({ start, end }) => {
            const masterValue = dataList[start][masterKey];
            rowSpans[start][masterKey] = end - start;
            for (let i = start + 1; i < end; i++) {
                rowSpans[i][masterKey] = 0;
            }
            // 3. 그 외 병합 대상 칼럼 처리
            mergeConfig.forEach(({ key: colKey, row, nullable }) => {
                if (colKey === masterKey) return;
                let prevValue = null;
                let localStart = start;
                let mergeCount = 1;
                for (let i = start; i < end; i++) {
                    const currVal = dataList[i][colKey];
                    const isMergeable = nullable
                        ? currVal === prevValue
                        : currVal === prevValue && currVal !== '' && currVal !== null;
                    if (i === start) {
                        rowSpans[i][colKey] = 1;
                        prevValue = currVal;
                        continue;
                    }
                    if (isMergeable) {
                        rowSpans[localStart][colKey] += 1;
                        rowSpans[i][colKey] = 0;
                        mergeCount += 1;
                    } else {
                        rowSpans[i][colKey] = 1;
                        localStart = i;
                        mergeCount = 1;
                        prevValue = currVal;
                    }
                }
            });
        });
        // 4. 병합 대상이 아닌 컬럼 처리
        dataList.forEach((_, i) => {
            allColumns.forEach(colKey => {
                if (!(colKey in rowSpans[i])) {
                    rowSpans[i][colKey] = 1;
                }
            });
        });
        return rowSpans;
    };

    const rowSpans = computeRowSpans(state.dataList, mergeConfig ?? [], dataColumn);

    const { fontColor, primaryBackColor, lightBackColor, borderColorGray, hoverLightFontColor } = useDynamicStyle();

    const { EmptyIcon, NullIcon } = useSubIcon();

    useEffect(() => {
        search();
    }, [searchParams.searchCheck2, searchParams.searchGrdc]);
    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="15%" />
                        <col width="15%" />
                        <col width="15%" />
                        <col width="15%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <FidelityCommon
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                                setSearchParams={setSearchParams}
                                flag={true}
                            />
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className='search_btn_wrapper'>
                <span className='total_items'>전체&nbsp;<strong className={fontColor}>{pageInfo.totalItems}</strong>건</span>
                {searchParams.searchDateCls && (
                    <span style={{ background: 'yellow' }}>*분석일자는 {searchParams.searchDateCls.slice(0, 4)}년 {searchParams.searchDateCls.slice(4, 6)}월 {searchParams.searchDateCls.slice(6, 8)}일이며, 대상기간은 {searchParams.searchFromdate.slice(0, 4)}년 {searchParams.searchFromdate.slice(4, 6)}월 {searchParams.searchFromdate.slice(6, 8)}일 ~ {searchParams.searchTodate.slice(0, 4)}년 {searchParams.searchTodate.slice(4, 6)}월 {searchParams.searchTodate.slice(6, 8)}일</span>
                )}
                <div className='btn_container'>
                    <button onClick={search} disabled={state.isLoading ? 'disabled' : ''} className={`search_btn ${primaryBackColor}`}><Icons.Search16w />검색</button>
                    {excelFileName === '' ? <div></div> :
                        <ExcelDownload
                            excelHead={dataHead}
                            excelData={state.dataList}
                            searched={state.isSearched}
                            dataCode={dataColumn}
                            excelFileName={excelFileName}
                        />
                    }
                </div>
            </div>
            <div className='data_grid_container'>
                {state.isLoading ? <Loading /> :
                    <>
                        <hr className={`border-t-2 mr-1-1 ${borderColorGray}`} />
                        <div className={`data_list_table ${state.isSearched ? 'grid-animation' : ''}`}>
                            <table>
                                <MergedTableHeader
                                    headers={dataHead}
                                />
                                <tbody>
                                    {state.dataList.length === 0 ? (

                                        <tr>
                                            <td colSpan={1000} style={{ padding: '0' }}>
                                                <span className={`data_empty ${lightBackColor}`}>
                                                    {state.isSearched ? EmptyIcon : NullIcon}
                                                    {state.isSearched ? '해당하는 데이터가 없습니다.' : '검색 버튼을 눌러 데이터를 조회하세요.'}
                                                </span>
                                            </td>
                                        </tr>
                                    ) : (
                                        state.dataList.map((item, rowIndex) => {
                                            const gridColor = rowIndex % 2 === 0 ? lightBackColor : '';
                                            return (
                                                <tr key={rowIndex} className={gridColor}>
                                                    {dataColumn.map((col, colIndex) => {
                                                        const span = rowSpans[rowIndex][col];
                                                        if (!span) return null;

                                                        const prefix = col;
                                                        const isClickable = popupPropsInfo.checked.includes(prefix);
                                                        const handleClick = () => {
                                                            const senData = {
                                                                emtInsttCd: state.dataList[rowIndex].EMT_INSTT_CD === "0" ? "" : state.dataList[rowIndex].EMT_INSTT_CD,
                                                                emtInsttNm: encodeURIComponent(encodeURIComponent(state.dataList[rowIndex].EMOG_NAME)),
                                                                iem_cd: state.dataList[rowIndex].IEM_ID,
                                                                targetData: dataColumn[colIndex] === 'RECHECK_CO' ? 'RE_EXMNT_RT' : dataColumn[colIndex] === 'ERROR_CO' ? 'ERRORRT' : dataColumn[colIndex],
                                                                isIemCdResultView: 1,
                                                            };
                                                            const totalObj = Object.assign({}, searchParams, senData);

                                                            let popup = null;

                                                            if (state.isSearched) {
                                                                localStorage.setItem(popupPropsInfo.localStorageName, JSON.stringify(totalObj));
                                                                popup = window.open(popupPropsInfo.popupAddress, "팝업", `scrollbars=1, resizable=0, width=1500, height=700, left=30 ,top=30`);
                                                            }
                                                        };

                                                        const cellStyle = isClickable ? `underline-pointer ${hoverLightFontColor}` : '';

                                                        return (
                                                            <td
                                                                key={colIndex}
                                                                rowSpan={span}
                                                                onClick={isClickable ? handleClick : undefined}
                                                                className={cellStyle}
                                                            >
                                                                {item[col]}
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            )
                                        })
                                    )}
                                    <tr className='sticky bottom-0 bg_tr_row'>
                                        {total.length > 0 && (() => {
                                            const item = total[0];
                                            // 1. 테이블 헤더 순서에 맞춰서 출력할 값들을 배열로 만듭니다.
                                            const displayValues = [
                                                item.RELM_NAME,
                                                item.IEM_NAME,
                                                item.NRMLT_CNT,
                                                item.NRMLT_STRE_RT,
                                                item.RECHECK_CNT,
                                                item.RE_EXMNT_RT,
                                                item.ERROR_CNT,
                                                item.ERRORRT
                                            ];
                                            return displayValues.map((val, index) => (
                                                <td key={`sum-${index}`}>
                                                    {/* 데이터가 문자열일 경우에만 trim() 적용 */}
                                                    <strong>{typeof val === 'string' ? val.trim() : val}</strong>
                                                </td>
                                            ));
                                        })()}
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <hr className='mr-1-1 co_border_gray' />
                    </>
                }
            </div>
            <div className='pt-3'>
                <h5>* 각 항목 설명</h5>
                <p>&ensp;- 정상 건 : 오류 및 재검토 기준에 해당되는 내용이 없는 건</p>
                <p>&ensp;- 재검토 건  : 오류는 아니지만 재확인 필요한 건</p>
                <p>&ensp;※ [데이터 검토] 내용을 통해 데이터가 정상적으로 전송되었으나, 전송 이후 오류 및 재검토의 재확인이 필요한 내용임</p>
            </div>
        </Main >
    )
}

export default FidelityInputStatic;